import { useState } from 'react';
import { X, Megaphone } from 'lucide-react';

export function NewsTicker() {
  const [isVisible, setIsVisible] = useState(true);

  const newsItems = [
    //"ತಾಲ್ಲೂಕಿನಾದ್ಯಂತ ಎಲ್ಲ ವಿಪ್ರ ಬಂಧುಗಳ ಮನೆಗೆ ವೇದ ಮಾತೆ ಗಾಯತ್ರಿ ದೇವಿಯ ಕ್ಯಾಲೆಂಡರ್ ಮತ್ತು 2026 ರ ಕ್ಯಾಲೆಂಡರ್ ವಿತರಿಸಲಾಗುತ್ತಿದೆ."
    "ಕರ್ನಾಟಕ ರಾಜ್ಯ ಬ್ರಾಹ್ಮಣ ಅಭಿವೃದ್ಧಿ ಮಂಡಳಿ ವತಿಯಿಂದ 2025- 26 ನೇ ಸಾಲಿನ ವಿಪ್ರ ಸ್ವ ಉದ್ಯೋಗ ನೇರ ಸಾಲ ವಿತರಣಾ ಕಾರ್ಯಕ್ರಮ ತಾರೀಕು 03/01/2026 ಶನಿವಾರ ಬೆಳಗ್ಗೆ 10 ಗಂಟೆಗೆ ನಡೆಯಲಿದೆ. ಸ್ಥಳ :- ತಾಲ್ಲೂಕು ಪಂಚಾಯತಿ ಕಾರ್ಯಾಲಯ , ಚಿಂತಾಮಣಿ. ಎಲ್ಲ ವಿಪ್ರ ಬಾಂಧವರು ಕಾರ್ಯಕ್ರಮಕ್ಕೆ ಹಾಜರಾಗಿ ಯಶಸ್ವಿಗೊಳಿಸಬೇಕೆಂದು ಕೋರಿದೆ."
  ];

  if (!isVisible) return null;

  return (
    <div className="bg-[#800000] text-white overflow-hidden relative h-10 flex items-center z-40">
      <div className="container mx-auto flex items-center h-full px-4 relative">
        <div className="bg-[#800000] z-10 pr-4 flex items-center h-full shadow-[4px_0_8px_-4px_rgba(0,0,0,0.3)]">
          <span className="font-bold text-[#F59E0B] flex items-center text-sm uppercase tracking-wider whitespace-nowrap">
            <Megaphone className="h-4 w-4 mr-2" />
            Latest Updates
          </span>
        </div>
        
        <div className="flex-1 overflow-hidden relative h-full flex items-center">
            <div className="animate-marquee whitespace-nowrap flex items-center">
              {newsItems.map((item, index) => (
                <span key={index} className="mx-8 text-sm font-medium inline-block">
                  {item}
                </span>
              ))}
              {/* Duplicate for seamless scroll */}
              {newsItems.map((item, index) => (
                <span key={`dup-${index}`} className="mx-8 text-sm font-medium inline-block">
                  {item}
                </span>
              ))}
            </div>
        </div>
      </div>
    </div>
  );
}
